<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <!-- <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo"/>
    </CHeaderBrand> -->
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard"> Dashboard </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/loans" exact> Loans </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/profiles/staff"> Staff </CHeaderNavLink>
      </CHeaderNavItem>
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink href="http://localhost:8081/">
          Administration
        </CHeaderNavLink>
      </CHeaderNavItem> -->
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <TheHeaderDropdownAccnt />
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink to="/">
          <CIcon name="cil-lock-locked"/>Logout
        </CHeaderNavLink>
      </CHeaderNavItem> -->

      <CHeaderNavItem class="d-md-down-none mt-3 mx-2">
        <p @click="logout()" style="cursor: pointer;"><CIcon name="cil-lock-locked" /></p>
        <!-- <CHeaderNavLink to="/">
          <CIcon name="cil-lock-locked" />
        </CHeaderNavLink> -->
      </CHeaderNavItem>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import LocalStorageService from "../APIs/token";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  methods: {
    // logout() {
    //   this.isModalOpen = false;
    //   this.errorMessage = "";
    //   isStatementChecking = false;
    // },
    logout() {
      // console.log("here");
      // this.isModalOpen = false;
      // this.errorMessage = "";
      // isStatementChecking = false;
      // localStorage.removeItem("user")
      LocalStorageService.clearToken();
      // localStorage.removeItem(constances.USER_DETALS)
      this.$router.push("/login");
    },
  },
};
</script>
